module.exports = __webpack_public_path__ + "static/media/ic_计划删除.b6a4774f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_计划删除.svg
// module id = 330
// module chunks = 0